import _asyncToGenerator from "/app/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/app/web/node_modules/@babel/runtime/regenerator";
import { Button, Empty, List, message, Popconfirm, Space } from 'antd';
import { getNotificationStore, NotificationLoader } from 'core/modules/notifications/notification.store';
import { useTranslation } from 'react-i18next';
import { NotificationItem } from 'src/components/Notifications/NotificationItem';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Notifications = function Notifications() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getNotificationStore = getNotificationStore(),
      isLoadingKey = _getNotificationStore.isLoadingKey,
      notifications = _getNotificationStore.notifications,
      unreadNotifications = _getNotificationStore.unreadNotifications,
      markAllNotificationsAsRead = _getNotificationStore.markAllNotificationsAsRead,
      deleteAllNotifications = _getNotificationStore.deleteAllNotifications;

  var isLoading = isLoadingKey(NotificationLoader.DeleteAllNotifications) || isLoadingKey(NotificationLoader.MarkAllNotificationsAsRead);

  function onMarkAllAsRead() {
    return _onMarkAllAsRead.apply(this, arguments);
  }

  function _onMarkAllAsRead() {
    _onMarkAllAsRead = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return markAllNotificationsAsRead();

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              message.error(t('unknownError'));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));
    return _onMarkAllAsRead.apply(this, arguments);
  }

  function onDeleteAll() {
    return _onDeleteAll.apply(this, arguments);
  }

  function _onDeleteAll() {
    _onDeleteAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return deleteAllNotifications();

            case 3:
              _context2.next = 8;
              break;

            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);
              message.error(t('unknownError'));

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 5]]);
    }));
    return _onDeleteAll.apply(this, arguments);
  }

  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "actions",
      children: /*#__PURE__*/_jsxs(Space, {
        split: "|",
        children: [/*#__PURE__*/_jsx(Button, {
          type: "link",
          disabled: isLoading || unreadNotifications === 0,
          onClick: function onClick() {
            return onMarkAllAsRead();
          },
          children: t('notifications.markAllAsRead')
        }), /*#__PURE__*/_jsx(Popconfirm, {
          getPopupContainer: function getPopupContainer(trigger) {
            return trigger.parentElement;
          },
          title: t('areYouSure'),
          onConfirm: function onConfirm() {
            return onDeleteAll();
          },
          disabled: isLoading || notifications.length === 0,
          children: /*#__PURE__*/_jsx(Button, {
            type: "link",
            disabled: isLoading || notifications.length === 0,
            loading: isLoadingKey(NotificationLoader.DeleteAllNotifications),
            children: t('notifications.deleteAll')
          })
        })]
      })
    }), /*#__PURE__*/_jsx(List, {
      dataSource: notifications,
      locale: {
        emptyText: /*#__PURE__*/_jsx(Empty, {
          description: t('notifications.empty')
        })
      },
      renderItem: function renderItem(item) {
        return /*#__PURE__*/_jsx(NotificationItem, {
          notification: item
        }, item.id);
      }
    })]
  });
}; // Styles

var Container = styled.div.withConfig({
  displayName: "Notifications__Container",
  componentId: "sc-1qijnxa-0"
})(["max-height:80vh;width:400px;overflow-y:scroll;margin:-12px -16px;.ant-list{margin-top:35px;}.ant-space-item-split{color:#999;}.actions{position:absolute;top:0;left:10px;right:0;padding:6px 12px;background-color:white;box-shadow:0 1px 0 #ededed;z-index:1;display:flex;align-items:center;justify-content:flex-end;.ant-btn{font-size:0.9em;height:auto;color:#666;padding:0 6px;&[disabled]{opacity:0.2;}}}"]);